import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Logs } from "lucide-react";
import { useMemo, useState } from "react";

const VersionHistoryItemChanges = ({ parentRef }) => {
  const [isOpen, setIsOpen] = useState(false);

  const offset = useMemo(() => {
    if (parentRef.current) {
      const { width } = parentRef.current.getBoundingClientRect();
      return width;
    }
    return 0;
  }, [parentRef, isOpen]);

  const sheetContentClasses = useMemo(() => {
    return `data-[state=open]:translate-x-[${offset}px] data-[state=closed]:translate-x-full transition-transform duration-500 ease-in-out max-w-[calc(100vw-${offset}px)] w-full !shadow-none border-none`;
  }, [offset]);

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button
          variant="borderless"
          className="w-full text-secondary flex items-center justify-start hover:text-white"
        >
          <Logs size={24} />
          Change Log
        </Button>
      </SheetTrigger>
      <SheetContent className={sheetContentClasses} side="right">
        <SheetHeader>
          <SheetTitle>Change log</SheetTitle>
        </SheetHeader>
        {/* Content of the change log goes here */}
      </SheetContent>
    </Sheet>
  );
};

export default VersionHistoryItemChanges;
